import A11yDialog from 'a11y-dialog';
import { gsap, Power4 } from 'gsap';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { loader } from '../utils/loader';

/**
 * Dialog
 */
class Dialog {
	/**
	 * Construct
	 *
	 * @description set state and cache elements.
	 */
	constructor(element) {
		/* Queries */
		this.element = element;

		if (!this.element) {
			return;
		}

		this.dialog = new A11yDialog(this.element);
		this.dialogDocument = this.element.querySelector('[role="document"]');
		this.backdrop =  this.element.querySelector('.rx-backdrop');

		/* States */
		this.states = { isOpen: 'is-open' };

		/* Initilize */
		this.init();
	}

	/**
	 * Init
	 *
	 * @description initialize.
	 */
	init() {
		if (!this.dialog) {
			return;
		}

		this.animation = gsap
			.timeline({
				paused: true,
				onReverseComplete: () => this.onDialogHideAnimationDone(),
				defaults: { duration: 0.25 }
			})
			.set(this.dialogDocument, { autoAlpha: 0, y: '1rem' })
			.set(this.backdrop, { autoAlpha: 0 })
			.to(this.dialogDocument, { autoAlpha: 1, y: '0' })
			.to(this.backdrop, { autoAlpha: 1 }, '<');

		this.dialog.on('show', () => this.onDialogShow());
		this.dialog.on('hide', () => this.onDialogHide());
	}

	/**
	 * On Dialog Show
	 *
	 * @description show dialog event.
	 */
	onDialogShow() {
		disableBodyScroll(this.dialogDocument);
		this.element.classList.add(this.states.isOpen);
		this.animation.play();
	}

	/**
	 * On Dialog Hide
	 *
	 * @description hide dialog event.
	 */
	onDialogHide() {
		this.animation.reverse();
	}

	/**
	 * On Dialog Hide Animation Done
	 *
	 * @description hide dialog animation complete event.
	 */
	onDialogHideAnimationDone() {
		this.element.classList.remove(this.states.isOpen);
		enableBodyScroll(this.dialogDocument);
	}
}

/**
 * Create Dialog
 */
export const createDialog = () => {
	loader('.rx-dialog', Dialog);
};
